// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../config/styles';
import blueCloud from '../../../images/blue-cloud.png';
import blueCloudMobile from '../../../images/blue-cloud-mobile.png';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 70,
  },
  title: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MAX,
    color: GlobalStyles.color.COLOR_SECONDARY,
    marginBottom: 20,
  },
  helpersContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    maxWidth: '100%',
    width: 750,
    flexDirection: 'column',
    [theme.breakpoints.down(750)]: {
      width: '95%',
    },
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  text: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    color: GlobalStyles.color.COLOR_PRIMARY,
    [theme.breakpoints.down(700)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    },
  },
  marginBottom: {
    marginBottom: 20,
    [theme.breakpoints.down(650)]: {
      marginBottom: 5,
    },
    [theme.breakpoints.down(500)]: {
      marginBottom: 20,
    },
  },
  downloadIconContainer: {
    marginTop: 20,
    marginBottom: 40,
    [theme.breakpoints.down(650)]: {
      marginTop: 10,
    },
    [theme.breakpoints.down(500)]: {
      marginTop: 20,
    },
  },
  bottomInfoContainer: {
    backgroundImage: `url(${blueCloud})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    width: 700,
    height: 400,
    padding: '20px 30px 40px 60px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down(700)]: {
      width: 600,
      padding: '0 30px 0 70px',
      height: 350,
    },
    [theme.breakpoints.down(600)]: {
      width: '97%',
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
      paddingTop: -10,
      height: 300,
    },
    [theme.breakpoints.down(500)]: {
      backgroundImage: `url(${blueCloudMobile})`,
      minWidth: '100%',
      maxWidth: '100%',
      padding: '70px 10px',
      height: 'auto',
      backgroundSize: '100% 100%',
    },
  },
  marginLeft: {
    marginLeft: 15,
    [theme.breakpoints.down(500)]: {
      marginLeft: 0,
    },
  }
});

export default styles;
